<div class="jeopary-mode-grid">
  <h2>
    Game Rules
  </h2>
  <div class="slides-container">
    <div class="slides-viewport" (mousedown)="startDrag($event)" (mouseup)="endDrag($event)"
         (mousemove)="onPointerMove($event)" (touchstart)="startDrag($event)" (touchend)="endDrag($event)"
         (touchmove)="onPointerMove($event)">
      <div class="slides-wrapper">
        <!-- General information -->
        <div #slide class="slide jeopardy-question-panel">
          <h4>{{slides[0].title}}</h4>
          <br>
          <p>{{slides[0].content[0]}}</p>
          <ul class="difficulty-list">
            <li>
              <img src="{{slides[0].images[0]}}" alt="100">
              <p>{{i18n.str('challengeu.rules_very_easy', 'VERY EASY')()}}</p>
            </li>
            <li>
              <img src="{{slides[0].images[1]}}" alt="200">
              <p>{{i18n.str('challengeu.rules_easy', 'EASY')()}}</p>
            </li>
            <li>
              <img src="{{slides[0].images[2]}}" alt="300">
              <p>{{i18n.str('challengeu.rules_medium', 'MEDIUM')()}}</p>
            </li>
            <li>
              <img src="{{slides[0].images[3]}}" alt="400">
              <p>{{i18n.str('challengeu.rules_difficult', 'DIFFICULT')()}}</p>
            </li>
            <li>
              <img src="{{slides[0].images[4]}}" alt="500">
              <p>{{i18n.str('challengeu.rules_very_difficult', 'VERY DIFFICULT')()}}</p>
            </li>
          </ul>
        </div>

        <!-- selecting a question -->
        <div #slide class="slide jeopardy-question-panel">
          <h4>{{slides[1].title}}</h4>
          <br>
          <div>
            {{slides[1].content[0]}}
          </div>
        </div>

        <!-- scoring -->
        <div #slide class="slide jeopardy-question-panel">
          <h4>{{slides[2].title}}</h4>
          <br>
          <p>
            {{slides[2].content[0]}}
          </p>
          <br>
          <p class="inline-image image-left">
            <img src="{{slides[2].images[0]}}" alt="55" />
            <span>{{slides[2].content[1]}}</span>
          </p>
        </div>

        <!-- Jokers -->
        <div #slide class="slide jeopardy-question-panel">
          <h4>{{slides[3].title}}</h4>
          <br>
          <p>
            {{slides[3].content[0]}}
          </p>
          <br>
          <ul>
            <li class="inline-image image-left">
              <img src="{{slides[3].images[0]}}" [alt]="i18n.str('challengeu.jokers_icon', 'jokers icon')()" />
              {{slides[3].content[1]}}
            </li>
            <li class="inline-image image-left">
              <img src="{{slides[3].images[1]}}"
                   [alt]="i18n.str('challengeu.skip_question_icon', 'skip question icon')()" />
              {{slides[3].content[2]}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <a class="arrow left-arrow" href="#" [class.disabled]="activeSlideIndex === 0" (click)="changeSlide($event, 'left')"
       title="Click to shift the list to the left"></a>
    <a class="arrow right-arrow" href="#" [class.disabled]="activeSlideIndex === slides.length-1"
       (click)="changeSlide($event, 'right')" title="Click to shift the list to the right"></a>

    <ul class="points">
      @for (item of [].constructor(slides.length); track $index; let i = $index) {
      <li class="point active" [class.active]="activeSlideIndex === i" (click)="selectSlide($event, i)"
          title="{{slides[i].title}}">
        <i></i>
      </li>
      }
    </ul>
  </div>
  <div>
    <br>
    <p class="jeopardy-button primary">
      <a class="neon" href="#" title="{{i18n.str('challengeu.back_main_menu', 'BACK TO MAIN MENU')()}}"
         routerLink="/main-menu">
        {{i18n.str('challengeu.back_main_menu', 'BACK TO MAIN MENU')()}}
      </a>
    </p>
  </div>
</div>
